import { useQueryGtfsResourceById } from "../../Queries";
import { useContext, useEffect, useId } from "react";
import { ToolsContext } from "../../ToolsContext";
import { RLayer, RSource, useMap } from "maplibre-react-components";
import { LngLatBounds } from "maplibre-gl"

export function RoutesMl() {
    const tool = useContext(ToolsContext);
    const GRoute = tool.propertyEditor.edit;
    const {isPending, error, data} = useQueryGtfsResourceById('shapes/route',GRoute.route_id,'both');
    const id = useId();
    const map = useMap("map-ml");
  
    const Layers = [];

    useEffect(() => {

        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu linii komunikacyjnej na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ 
        if (!data) return;
        const coordinates = data
            .flatMap(obiekt => Object.values(obiekt))
            .flat();

        const bounds = coordinates.reduce((bounds, coord) => {
            return bounds.extend(coord);
        }, new LngLatBounds(coordinates[0], coordinates[0]));

        map.fitBounds(bounds, {
            padding: 20
        });
    },[Layers,data]);


    if (isPending || error || !data) return;

    const layout = {
        'line-cap': 'round',
        'line-join': 'round',
    }

    const paintFirst = { 
        'line-color': '#' + GRoute.route_color,
        'line-width': 6,
        //'line-opacity': 0.55
    };

    const paint = { 
        'line-color': '#' + GRoute.route_color,
        'line-width': 3,
        'line-dasharray': [6, 3]
        //'line-opacity': 0.55
    };

    data.forEach((element) => {
        let first = true;
        for (const [key, value] of Object.entries(element)) {
            
            Layers.push(
                <>
                    <RSource 
                        id={'S' + id + '_' + key}
                        type="geojson"
                        data={
                            {
                                "type": "FeatureCollection",
                                "features": [
                                  {
                                    "type": "Feature",
                                    "geometry": {
                                      "coordinates": [ ...value ],
                                      "type": "LineString"
                                    }
                                  }
                                ]
                            }
                        }
                    /> 
                    <RLayer 
                        source={'S' + id + '_' + key}
                        id={'L' + id + '_' + key}
                        type="line"
                        paint={first ? paintFirst : paint}
                        layout={layout}
                    />
                </>
            )     
            first = false;
        }
    })
   

    return (
        <>
            {Layers}
        </>
    )
}